import { useState } from "react";
import { Form, Alert } from "react-bootstrap";
import Button from "../../components/Button/Button";
import Select from "../../components/Select/Select";
import Input from "../../components/Input/Input";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FaEye } from "react-icons/fa";

const HomeworkForm = ({
  programs,
  programChangeHandler,
  programRemoveHandler,
  onSubmitHandler,
  onChangeHandler,
  programData,
  subjectData,
  program_id,
  subject_id,
  start_date,
  end_date,
  homework_type,
  homework_title,
  homework_description,
  assigned_date,
  homework_attachment_view,
}) => {
  const [errorMsg, setErrorMsg] = useState("");

  // File validation logic
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];

    if (!allowedTypes.includes(file.type)) {
      setErrorMsg("Only valid document or image files are allowed.");
      e.target.value = "";
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      // > 10 MB
      setErrorMsg("File size cannot exceed 10 MB.");
      e.target.value = "";
      return;
    }

    setErrorMsg("");
    onChangeHandler(e);
  };

  return (
    <Form onSubmit={onSubmitHandler}>
      {errorMsg && (
        <Alert variant="danger" className="py-2 text-danger">
          {errorMsg}
        </Alert>
      )}

      <div className="row">
        <div className="col-md-6">
          <Select
            name="program_id"
            label="Class"
            value={program_id}
            id="program_id"
            options={programData && [...programData]}
            onChangeHandler={onChangeHandler}
            placeholder="Select Class"
            required={true}
          />
        </div>

        <div className="col-md-6">
          <Select
            name="subject_id"
            label="Subject"
            value={subject_id}
            id="subject_id"
            options={subjectData && [...subjectData]}
            onChangeHandler={onChangeHandler}
            placeholder="Select Subject"
            required={true}
          />
        </div>

        <div className="col-md-6">
          <Select
            name="homework_type"
            label="Type"
            value={homework_type}
            id="homework_type"
            options={[
              { id: "daily", name: "Daily" },
              { id: "weekly", name: "Weekly" },
            ]}
            onChangeHandler={onChangeHandler}
            placeholder="Select Type"
            required={true}
          />
        </div>

        {homework_type === "weekly" && (
          <>
            <div className="col-md-3">
              <Input
                label="Start Date"
                type="date"
                name="start_date"
                onChangeHandler={onChangeHandler}
                placeholder="Enter Start Date"
                value={start_date}
                required={true}
              />
            </div>
            <div className="col-md-3">
              <Input
                label="End Date"
                type="date"
                name="end_date"
                onChangeHandler={onChangeHandler}
                placeholder="Enter End Date"
                value={end_date}
                required={true}
              />
            </div>
          </>
        )}

        {homework_type === "daily" && (
          <div className="col-md-6">
            <Input
              label="Assigned Date"
              type="date"
              name="assigned_date"
              onChangeHandler={onChangeHandler}
              id="assigned_date"
              value={assigned_date}
              placeholder="Enter Assigned Date"
              required={true}
            />
          </div>
        )}

        <div className="col-md-12">
          <Input
            label="Title"
            type="text"
            name="homework_title"
            onChangeHandler={onChangeHandler}
            value={homework_title}
            id="homework_title"
            placeholder="Enter Title"
            required={true}
          />
        </div>

        <div className="col-md-12 mt-1">
          <Form.Label>Description</Form.Label>
          <CKEditor
            editor={ClassicEditor}
            data={homework_description}
            onChange={(event, editor) => {
              const data = editor.getData();
              onChangeHandler({
                target: { name: "homework_description", value: data },
              });
            }}
          />
        </div>

        <div className="col-md-12">
          {homework_attachment_view && (
            <div className="mb-2 mt-2">
              <strong>Current Attachment:</strong>{" "}
              <FaEye
                style={{ cursor: "pointer", color: "var(--color-link)" }}
                onClick={() => window.open(homework_attachment_view, "_blank")}
              />
            </div>
          )}

          <Input
            label="Upload Attachment"
            type="file"
            name="homework_attachment"
            id="homework_attachment"
            onChangeHandler={handleFileChange}
            placeholder="Upload Attachment"
            accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif,.webp"
          />

          {/* File Upload Note */}
          <small className="text-muted">
            Allowed file types:{" "}
            <strong>PDF,DOC,DOCX, PPT, JPG, JPEG, PNG, GIF, WEBP</strong>.
            <br />
            Maximum file size: <strong>10 MB</strong>.
          </small>
        </div>
      </div>

      <div className="row justify-content-end mt-2">
        <div className="col-md-1 mx-4">
          <Button variant="success" type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default HomeworkForm;
